import { useState, useRef } from 'react'

export const useSteps = <T,>(initialStep: T) => {
  const [currentStep, setCurrentStep] = useState<T>(() => initialStep)
  const stepsSequence = useRef<T[]>([])

  const setStep = (step: T) => {
    stepsSequence.current.push(currentStep)
    setCurrentStep(step)
  }

  const onBack = () => {
    // in case user started wizard from the middle - let him go back to the first step and start process over
    if (stepsSequence.current.length === 0) {
      setCurrentStep(initialStep)
    }

    const lastStep = stepsSequence.current.pop()
    if (lastStep) {
      setCurrentStep(lastStep)
    }
  }

  return { setStep, onBack, currentStep, setCurrentStep }
}
